<template>
	<div ref="details-section" class="details-section">
		<div class="title">{{ $t('main.details-tabs.details') }}</div>
		<div class="content">
			<div class="mobile col1">
				<span v-if="game.genre">{{ $t('main.genre') }}</span>
				<span v-if="game.publisher">{{ $t('main.publisher') }}</span>
				<span v-if="game.developer">{{ $t('main.developer') }}</span>
			</div>
			<div class="mobile col2">
				<span v-if="game.genre">{{ game.genre }}</span>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-if="game.publisher" v-html="getLocaleString(game.publisher)"></span>
				<span v-if="game.developer">{{ game.developer }}</span>
			</div>
			<div v-if="game.genre" class="desktop">
				<span>{{ $t('main.genre') }}</span>
				<span>{{ game.genre }}</span>
			</div>
			<div v-if="game.publisher" class="desktop">
				<span>{{ $t('main.publisher') }}</span>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-html="getLocaleString(game.publisher)"></span>
			</div>
			<div v-if="game.developer" class="desktop">
				<span>{{ $t('main.developer') }}</span>
				<span>{{ game.developer }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { getLocaleString } from '../../../plugins/helpers';

export default {
	name: 'GameDetailsDetailsSection',
	components: {},
	props: {
		game: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {
		language() {
			return this.$i18n.locale;
		},
	},
	mounted() {
		this.$emit('setRef', 'details', this.$refs['details-section']);
	},
	methods: {
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
	},
};
</script>

<style lang="less" scoped>
.details-section {
	height: 100%;
	margin-bottom: 40px;
	padding: 0 20px;
	user-select: none;
	width: 100%;
	.title {
		color: white;
		font-size: 20px;
		height: 40px;
		letter-spacing: -0.4px;
	}
	.content {
		background-color: #27292c;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 5px;
		box-shadow: 0 0 1px 0 #000000;
		color: #7e7e7f;
		display: flex;
		font-size: 14px;
		letter-spacing: -0.28px;
		line-height: 26px;
		margin: auto;
		padding: 23px 20px;
		width: auto;
		.desktop {
			display: none;
		}
		.mobile {
			&.col1 {
				margin-right: 20px;
			}
			&.col2 {
				color: #dcdcdc;
			}
		}
		span {
			display: block;
		}
		& ::v-deep p {
			display: inline-block;
			margin: 0;
		}
	}
}

@media (min-width: 768px) {
	.details-section {
		margin-bottom: 50px;
		.content {
			padding: 30px 50px;
			.desktop {
				display: block;
				&:not(:last-child) {
					margin-right: 100px;
				}
				span:last-child {
					color: white;
				}
			}
			.mobile {
				display: none;
			}
		}
	}
}

@media (min-width: 1024px) {
	.details-section {
		.title {
			font-size: 16px;
			letter-spacing: -0.32px;
			margin: 40px auto 0;
			padding-top: 5px;
			width: 770px;
		}
		.content {
			font-size: 12px;
			letter-spacing: -0.24px;
			line-height: 1.75;
			padding: 20px 35px;
			width: 770px;
			.desktop {
				&:not(:last-child) {
					margin-right: 150px;
				}
			}
		}
	}
}

@media (min-width: 1280px) {
	.details-section {
		.title {
			width: 960px;
		}
		.content {
			width: 960px;
			.desktop {
				&:not(:last-child) {
					margin-right: 225px;
				}
			}
		}
	}
}

@media (min-width: 1440px) {
	.details-section {
		display: flex;
		margin: 50px auto 0;
		padding: 0;
		width: 1080px;
		.title {
			color: white;
			font-size: 20px;
			letter-spacing: -0.4px;
			margin: 0;
			width: 250px;
		}
		.content {
			flex: 1;
			font-size: 14px;
			letter-spacing: -0.28px;
			line-height: 26px;
			margin: 0 0 0 20px;
			padding: 30px 50px;
			.desktop {
				&:not(:last-child) {
					margin-right: 150px;
				}
			}
		}
	}
}

@media (min-width: 1600px) {
	.details-section {
		margin: 80px auto 0;
		width: 1200px;
		.title {
			width: 270px;
		}
		.content {
			.desktop {
				&:not(:last-child) {
					margin-right: 175px;
				}
			}
		}
	}
}

@media (min-width: 1920px) {
	.details-section {
		width: 1440px;
		.title {
			width: 340px;
		}
		.content {
			.desktop {
				&:not(:last-child) {
					margin-right: 225px;
				}
			}
		}
	}
}
</style>
